module.exports = __webpack_public_path__ + "b00cde7b77d6bfc3a4f469e5696e017b.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/rockers.svg
 ** module id = 437
 ** module chunks = 0
 **/